import React from "react";

const ASP_Content_Rotator = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Content Rotator</h1>
      <p>This is the ASP Content Rotator page content.</p>
    </div>
  );
};

export default ASP_Content_Rotator;
